/*
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-05-23 09:59:10
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-04 14:08:33
 */

const BASE_URL = '/lishui-gov'
const BASE = '/dev-api'
import request from '@/common/api/request'

// 区域划分
export const getArea = params =>
  request(BASE_URL + '/govdictArea/getArea', { params })
// 钉钉群消息获取
export const getRobotList = params =>
  request(BASE_URL + '/robotManage/getRobotList', { params })
